"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { attachments: [] };
        this.selectedContentType = null;
        this.contextModal = {
            label: 'Add Program Attachment',
            instructions: 'Select from the options listed below',
            options: {
                attachment: [
                    {
                        label: 'Book',
                        value: 'BOOK',
                        fn: this.onAddContent.bind(this)
                    },
                    {
                        label: 'Document',
                        value: 'XDOC',
                        fn: this.onAddContent.bind(this)
                    },
                    {
                        label: 'External Source',
                        value: 'ESHL',
                        fn: this.onAddContent.bind(this)
                    }
                ]
            }
        };
    },
    onInput: function ({list}) {
        list && this.setState('attachments', list);
    },
    onAddContent: function (type) {
        switch (this.selectedContentType = type) {
        case 'BOOK':
        case 'XDOC':
        case 'ESHL':
            window.Extensions.run('Library', {
                page: 'myspace',
                type,
                callback: this.onProgramAttachmentInsert.bind(this)
            });
            break;
        }
    },
    dismissProvider: function () {
        switch (this.selectedContentType) {
        case 'BOOK':
        case 'XDOC':
        case 'ESHL':
            window.Extensions.quit('Library');
            break;
        }
        this.selectedContentType = null;
    },
    onToggleAddContent: function (emit) {
        emit('open', this.contextModal);
    },
    onViewAttachment: function ({type, reference}) {
        switch (this.selectedContentType = type) {
        case 'BOOK':
        case 'XDOC':
        case 'ESHL':
            window.Extensions.run('Library', {
                page: 'view',
                reference
            });
            break;
        }
    },
    onProgramAttachmentInsert: function (attachment) {
        if (!this.state.attachments)
            this.state.attachments = [];
        this.state.attachments.push(attachment);
        this.emit('change', this.state.attachments);
        this.dismissProvider();
    },
    onProgramAttachmentDelete: function (index) {
        this.emit('dialog', {
            type: 'warning',
            message: 'Are you sure about deleting this attachment?',
            actions: {
                yes: {
                    active: true,
                    fn: function () {
                        this.state.attachments.splice(index, 1);
                        this.emit('change', this.state.attachments.length ? this.state.attachments : '');
                    }.bind(this)
                }
            }
        });
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Programs/create/Content/components/Attachments.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    index_template = require("/workspace/src/views/components/Wrapper/index.marko"),
    Bx_template = require("../../../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    get_context_template = require("@marko-tags/context/src/components/get-context/index.marko"),
    get_context_tag = marko_loadTag(get_context_template),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    marko_attrs0 = {
        "class": "d-flex align-items-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("4c52a4"),
    marko_node0 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "5", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "btn btn-secondary btn-icon rounded-circle mr-2"
      },
    marko_attrs2 = {
        "class": "position-relative"
      },
    marko_node3 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "col"
      },
    marko_attrs4 = {
        "class": "font-medium-3"
      },
    marko_attrs5 = {
        "class": "col text-right"
      },
    marko_attrs6 = {
        "class": "btn btn-secondary m-25"
      },
    marko_attrs7 = {
        "class": "position-relative cursor-pointer"
      },
    marko_attrs8 = {
        "class": "position-absolute top-0 right-0 cursor-pointer m-50"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if ((!state.attachments.length) && input.editable) {
    out.be("div", marko_attrs0, "0", component);

    get_context_tag({
        __from: index_template,
        renderBody: function(out, {}, emit) {
          out.be("button", marko_attrs1, "1", component, null, 0, {
              onclick: __component.d("click", emit, false, [
                  "open",
                  component.contextModal
                ])
            });

          Bx_tag({
              type: "plus",
              class: "white-text"
            }, out, __component, "2");

          out.ee();

          Locale_tag({
              class: "text-muted",
              renderBody: function(out) {
                out.t("Add attachments like Book, Document, ... to the program");
              }
            }, out, __component, "3");
        }
      }, out, __component, "24");

    out.ee();

    out.n(marko_node0, component);

    out.n(marko_node1, component);

    out.n(marko_node2, component);
  } else {
    out.be("div", marko_attrs2, "7", component);

    if (state.attachments.length) {
      Row_tag({
          renderBody: function(out) {
            out.be("div", marko_attrs3, "9", component);

            out.be("h6", marko_attrs4, "10", component);

            Locale_tag({
                text: "Program Attachments"
              }, out, __component, "11");

            out.ee();

            out.ee();

            out.be("div", marko_attrs5, "12", component);

            if (input.editable) {
              get_context_tag({
                  __from: index_template,
                  renderBody: function(out, {}, emit) {
                    out.be("button", marko_attrs6, "13", component, null, 0, {
                        onclick: __component.d("click", emit, false, [
                            "open",
                            component.contextModal
                          ])
                      });

                    Bx_tag({
                        type: "plus",
                        class: "left",
                        style: "color:inherit"
                      }, out, __component, "14");

                    Locale_tag({
                        text: "Add",
                        class: "align-middle"
                      }, out, __component, "15");

                    out.ee();
                  }
                }, out, __component, "25");
            }

            out.ee();
          }
        }, out, __component, "8");

      out.n(marko_node3, component);
    }

    Row_tag(marko_mergeNestedTagsHelper({
        class: "attachments-list",
        renderBody: function(out, $nestedTagRow$0) {
          var $for$0 = 0;

          marko_forOf(state.attachments, function({ type, poster, title, reference }, index) {
            var $keyScope$0 = "[" + (($for$0++) + "]");

            Row_col_nested_tag({
                ns: "col-lg-2 col-md-3 col-4",
                qs: "col-2",
                hs: "col-2",
                fs: "col-1",
                class: "px-50",
                renderBody: function(out) {
                  out.be("div", marko_attrs7, "19" + $keyScope$0, component);

                  out.be("div", null, "20" + $keyScope$0, component, null, 0, {
                      onclick: __component.d("click", "onViewAttachment", false, [
                          {
                              type: type,
                              reference: reference
                            }
                        ])
                    });

                  Image_tag({
                      alt: "attachment",
                      src: poster,
                      title: title,
                      class: "img-fluid rounded"
                    }, out, __component, "21" + $keyScope$0);

                  out.ee();

                  if (input.editable) {
                    out.be("span", marko_attrs8, "22" + $keyScope$0, component, null, 0, {
                        onclick: __component.d("click", "onProgramAttachmentDelete", false, [
                            index
                          ])
                      });

                    Bx_tag({
                        type: "x",
                        class: "p-25 theme-bg-fade rounded-circle shadow"
                      }, out, __component, "23" + $keyScope$0);

                    out.ee();
                  }

                  out.ee();
                }
              }, $nestedTagRow$0);
          });
        }
      }), out, __component, "17");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
